import React from "react";
import MainSlider from "./MainSlider/MainSlider";
import { IImage } from "../../models/IImage";

interface MainSliderProps {
  mode: "mainSlider";
  images: IImage[];
}

interface RegularSliderProps {
  mode: "regularSlider";
}

type SliderProps = MainSliderProps | RegularSliderProps;

const Slider: React.FC<SliderProps> = (props) => {
  const sliderMode = props.mode;

  return <>{sliderMode === "mainSlider" ? <MainSlider images={props.images} /> : sliderMode === "regularSlider" ? "" : ""}</>;
};

export default Slider;
